import React from "react";
import { Avatar } from "antd";

const UserAvatar = ({ fullName, size = 40, style = {} }) => {
  if (!fullName) return <Avatar size={size} style={style} />;

  // Split the name
  let names = fullName.trim().split(" ");

  // Remove the first word if it's a prefix (ends with a dot or common short prefix)
  const firstWord = names[0].replace(".", "").toLowerCase();
  if (firstWord.length <= 3) {
    names = names.slice(1);
  }

  if (names.length === 0) return <Avatar size={size} style={style} />;

  const initials =
    names.length === 1
      ? names[0][0].toUpperCase()
      : (names[0][0] + names[names.length - 1][0]).toUpperCase();

  return (
    <Avatar
      size={size}
      style={{ ...style, backgroundColor: "#7265e6", color: "#fff" }}
    >
      {initials}
    </Avatar>
  );
};

export default UserAvatar;
